import { render, staticRenderFns } from "./sharecommon.vue?vue&type=template&id=db0c9346&scoped=true"
import script from "./sharecommon.vue?vue&type=script&lang=js"
export * from "./sharecommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0c9346",
  null
  
)

export default component.exports